export default {
      id: "warning-border--no-color-usage",
      viewBox: "0 0 17 17",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#warning-border--no-color",
      toString: function () {
        return this.url;
      }
    }